import React, { useState } from 'react'
import { IconSearch, IconBuilding, IconPackage, IconMoney, IconCalendar, IconChevronDown, IconX } from './Icons'

export default function FaqAccordion() {
  const [openIndex, setOpenIndex] = useState(null)
  const [searchQuery, setSearchQuery] = useState('')

  const faqItems = [
    {
      category: 'Настройка и Команда',
      icon: <IconBuilding size={14} />,
      question: 'Как пригласить нового сотрудника по ссылке?',
      answer: 'Перейдите в раздел «Настройки» ➔ вкладка «Профиль» (или «Команда»). В блоке «Код приглашения» скопируйте уникальную ссылку и отправьте её сотруднику. После регистрации подтвердите его заявку в списке сотрудников.'
    },
    {
      category: 'Настройка и Команда',
      icon: <IconBuilding size={14} />,
      question: 'Как изменить оклад, дневные ставки или бонусы за коробки?',
      answer: 'Перейдите в раздел «Настройки» ➔ вкладка «Расчёт ЗП». Задайте фиксированную ставку за смену/час, а также укажите надбавки за приёмку, выдачу и возвраты. Нажмите «Сохранить изменения» внизу страницы.'
    },
    {
      category: 'Настройка и Команда',
      icon: <IconBuilding size={14} />,
      question: 'Как сбросить или выдать новый PIN-код сотруднику?',
      answer: 'Перейдите в раздел «Настройки» ➔ вкладка «Команда». Найдите нужного сотрудника в списке и нажмите кнопку «Задать пароль» / «PIN-код».'
    },
    {
      category: 'Настройка и Команда',
      icon: <IconBuilding size={14} />,
      question: 'Как переключаться между несколькими ПВЗ?',
      answer: 'В самом верху бокового меню (или в шапке на мобильных) находится селектор активного ПВЗ. Кликните по нему, чтобы переключаться между пунктами или выбрать пункт «Все ПВЗ».'
    },

    {
      category: 'Смены и Операции',
      icon: <IconPackage size={14} />,
      question: 'Как сотрудник начинает и завершает рабочую смену?',
      answer: 'В разделе «Операции» сотрудник нажимает зелёную кнопку «▶ Начать смену» и вводит свой PIN-код. В конце дня нажимает «Завершить смену». Время работы и начисления ведутся автоматически.'
    },
    {
      category: 'Смены и Операции',
      icon: <IconPackage size={14} />,
      question: 'Как правильно вносить приёмку, выдачу и возвраты?',
      answer: 'В разделе «Операции» нажмите «＋ Добавить операцию». Выберите тип (Приёмка / Выдача / Возврат), укажите количество коробок и при необходимости добавьте комментарий.'
    },
    {
      category: 'Смены и Операции',
      icon: <IconPackage size={14} />,
      question: 'Что делать, если сотрудник забыл завершить смену?',
      answer: 'Владелец или Администратор может завершить затянувшиеся смены вручную в разделе «Операции» или отредактировать время в «Графике смен».'
    },

    {
      category: 'Зарплаты и Выплаты',
      icon: <IconMoney size={14} />,
      question: 'Как система рассчитывает зарплату сотрудников?',
      answer: 'Зарплата рассчитывается автоматически в реальном времени по заданной формуле: (Время смены × Оклад) + (Приёмка × Ставка) + (Выдача × Ставка) - Удержания + Премии.'
    },
    {
      category: 'Зарплаты и Выплаты',
      icon: <IconMoney size={14} />,
      question: 'Как сотрудник может оспорить удержание WB?',
      answer: 'В разделе «Зарплаты» сотрудник открывает нужную смену и нажимает «Оспорить» напротив удержания, прикрепляя фото/комментарий. Владелец видит значок спора и может одобрять или отклонять его.'
    },
    {
      category: 'Зарплаты и Выплаты',
      icon: <IconMoney size={14} />,
      question: 'Как отметить выданный аванс или зарплату?',
      answer: 'В разделе «Зарплаты» нажмите кнопку «Выплатить» напротив сотрудника. Укажите сумму и тип (Аванс / Расчет). Начисления автоматически уменьшатся на выданную сумму.'
    },

    {
      category: 'График смен',
      icon: <IconCalendar size={14} />,
      question: 'Как быстро составить график смен (2/2, 5/2)?',
      answer: 'В разделе «График смен» нажмите «Автосмены». Выберите сотрудника, шаблон графика (например, 2 через 2) и диапазон дат — система заполнит график за 2 секунды.'
    }
  ]

  const filteredFaqs = faqItems.filter(item => 
    item.question.toLowerCase().includes(searchQuery.toLowerCase()) ||
    item.answer.toLowerCase().includes(searchQuery.toLowerCase()) ||
    item.category.toLowerCase().includes(searchQuery.toLowerCase())
  )

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index)
  }

  return (
    <div className="faq-accordion-wrapper">
      <div className="faq-search-box">
        <span className="faq-search-icon">
          <IconSearch size={16} />
        </span>
        <input 
          type="text"
          className="faq-search-input"
          placeholder="Поиск по вопросам (например: PIN, ЗП, Инвайт)..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
        {searchQuery && (
          <button className="faq-search-clear" onClick={() => setSearchQuery('')}>
            <IconX size={14} />
          </button>
        )}
      </div>

      <div className="faq-list">
        {filteredFaqs.length === 0 ? (
          <div className="faq-empty">Ничего не найдено по вашему запросу</div>
        ) : (
          filteredFaqs.map((faq, index) => {
            const isOpen = openIndex === index
            return (
              <div key={index} className={`faq-item ${isOpen ? 'is-open' : ''}`}>
                <div className="faq-header" onClick={() => toggleAccordion(index)}>
                  <div className="faq-question-group">
                    <span className="faq-category-tag">
                      {faq.icon}
                      {faq.category}
                    </span>
                    <h4 className="faq-question-title">{faq.question}</h4>
                  </div>
                  <span className="faq-arrow" style={{ transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)' }}>
                    <IconChevronDown size={16} />
                  </span>
                </div>
                {isOpen && (
                  <div className="faq-answer-body animate-fade-in">
                    <p>{faq.answer}</p>
                  </div>
                )}
              </div>
            )
          })
        )}
      </div>

      <style>{`
        .faq-accordion-wrapper {
          display: flex;
          flex-direction: column;
          gap: 14px;
        }
        .faq-search-box {
          position: relative;
          display: flex;
          align-items: center;
        }
        .faq-search-icon {
          position: absolute;
          left: 12px;
          color: var(--text-secondary, #64748b);
          display: flex;
          align-items: center;
          pointer-events: none;
        }
        .faq-search-input {
          width: 100%;
          padding: 10px 36px;
          border-radius: 10px;
          background: var(--surface-color, rgba(255, 255, 255, 0.05));
          border: 1px solid var(--border-color, rgba(255, 255, 255, 0.12));
          color: var(--text-primary, #fff);
          font-size: 13.5px;
          outline: none;
          transition: all 0.2s ease;
        }
        .faq-search-input:focus {
          border-color: var(--wb-primary, #a855f7);
          box-shadow: 0 0 12px rgba(168, 85, 247, 0.15);
        }
        .faq-search-clear {
          position: absolute;
          right: 10px;
          background: transparent;
          border: none;
          color: var(--text-secondary, #64748b);
          cursor: pointer;
          padding: 4px;
          display: flex;
          align-items: center;
        }
        .faq-list {
          display: flex;
          flex-direction: column;
          gap: 8px;
        }
        .faq-empty {
          text-align: center;
          padding: 24px;
          color: var(--text-secondary, #64748b);
          font-size: 13.5px;
        }
        .faq-item {
          background: var(--surface-color, rgba(255, 255, 255, 0.03));
          border: 1px solid var(--border-color, rgba(255, 255, 255, 0.08));
          border-radius: 12px;
          overflow: hidden;
          transition: all 0.2s ease;
        }
        .faq-item.is-open {
          border-color: rgba(168, 85, 247, 0.35);
          background: rgba(168, 85, 247, 0.04);
        }
        .faq-header {
          padding: 14px 16px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          cursor: pointer;
          user-select: none;
          gap: 12px;
        }
        .faq-question-group {
          display: flex;
          flex-direction: column;
          gap: 4px;
        }
        .faq-category-tag {
          font-size: 10.5px;
          font-weight: 700;
          color: #a855f7;
          display: inline-flex;
          align-items: center;
          gap: 4px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }
        .faq-question-title {
          font-size: 14px;
          font-weight: 700;
          color: var(--text-primary, #fff);
          margin: 0;
          line-height: 1.35;
        }
        .faq-arrow {
          color: var(--text-secondary, #64748b);
          display: flex;
          align-items: center;
          transition: transform 0.2s ease;
        }
        .faq-answer-body {
          padding: 0 16px 14px 16px;
          border-top: 1px dashed var(--border-color, rgba(255, 255, 255, 0.08));
          margin-top: 4px;
          padding-top: 10px;
        }
        .faq-answer-body p {
          font-size: 13px;
          line-height: 1.55;
          color: var(--text-secondary, #cbd5e1);
          margin: 0;
        }
      `}</style>
    </div>
  )
}
